export default class Root {
  constructor() {
    this.selector = 'body';

    this.selectors = {
      footer: '.c-footer',
      header: '.header',
      adminBar: '#wpadminbar',
      announcementBar: '.c-announcement-bar--top',
    };
  }

  bootstrap() {
    this.onLoadResizeScroll();

    window.addEventListener('resize', this.onLoadResizeScroll.bind(this));
    window.addEventListener('scroll', this.onLoadResizeScroll.bind(this));
  }

  onLoadResizeScroll() {
    this.scrollBarWidth();
    this.updateProps();
  }

  updateProps() {
    const footer = document.querySelector(this.selectors.footer);
    const header = document.querySelector(this.selectors.header);
    const adminBar = document.querySelector(this.selectors.adminBar);
    const announcementBarTop = document.querySelector(this.selectors.announcementBar);

    if (header) {
      document.documentElement.style.setProperty('--header-height', `${header.clientHeight}px`);
    }

    if (footer) {
      document.documentElement.style.setProperty('--footer-height', `${footer.clientHeight}px`);
    }

    if (announcementBarTop) {
      document.documentElement.style.setProperty('--announcement-bar-height', `${announcementBarTop.clientHeight}px`);
    } else {
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
    }

    if (adminBar) {
      const styles = getComputedStyle(adminBar);
      let adminBarHeight = 0;

      if (styles.position === 'fixed') {
        adminBarHeight = adminBar.clientHeight;
      }

      if (styles.position === 'absolute') {
        adminBarHeight = 0;
      }

      document.documentElement.style.setProperty('--admin-bar-height', `${adminBarHeight}px`);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  scrollBarWidth() {
    document.documentElement.style.setProperty('--scrollbar-width', `${window.innerWidth - document.documentElement.clientWidth}px`);
  }
}
